// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*  imported from Product.module.scss  */
/* stylelint-disable */
.Product-module-ProductRoot_24E {
  display: grid;
  row-gap: 16px;
  align-items: flex-start;
  width: 100%;
  height: auto; }

.Product-module-ProductHeader_zOD {
  position: relative;
  grid-area: header;
  width: 100%; }

.Product-module-ProductBody_hFy {
  display: flex;
  flex-direction: column;
  align-items: baseline;
  grid-area: body;
  max-width: 100%;
  row-gap: 8px; }

.Product-module-ProductFooter_3Rv {
  display: flex;
  flex-direction: column;
  align-items: baseline;
  grid-area: footer;
  max-width: 100%; }
  .Product-module-Skeleton_1Bx .Product-module-ProductFooter_3Rv {
    gap: 8px; }

.Product-module-Column_2-x {
  display: flex;
  flex-direction: column;
  align-items: stretch; }

.Product-module-Column_2-x .Product-module-ProductFooter_3Rv {
  row-gap: 8px; }
  .Product-module-Column_2-x .Product-module-ProductFooter_3Rv.Product-module-Skeleton_1Bx {
    margin-top: 32px; }
    @media (max-width: 767px) {
      .Product-module-Column_2-x .Product-module-ProductFooter_3Rv.Product-module-Skeleton_1Bx {
        margin-top: 16px; } }

.Product-module-Column_2-x .Product-module-ProductFooter_3Rv.Product-module-Skeleton_1Bx {
  margin-top: 32px; }
  @media (max-width: 767px) {
    .Product-module-Column_2-x .Product-module-ProductFooter_3Rv.Product-module-Skeleton_1Bx {
      margin-top: 16px; } }

.Product-module-Column_2-x .Product-module-SkeletonTitle_3MD {
  max-width: 90%;
  margin-bottom: 0; }

.Product-module-Column_2-x .Product-module-SkeletonText_3UG {
  display: none; }
  .Product-module-Column_2-x .Product-module-SkeletonText_3UG:last-child {
    display: initial;
    max-width: 90%;
    height: 24px; }
    @media (max-width: 767px) {
      .Product-module-Column_2-x .Product-module-SkeletonText_3UG:last-child {
        height: 16px; } }

.Product-module-Row_2AA {
  grid-template-areas: 'header body footer';
  grid-template-columns: 200px 1fr 200px;
  column-gap: 32px; }
  @media (max-width: 1439px) {
    .Product-module-Row_2AA {
      column-gap: 16px;
      grid-template-columns: minmax(164px, 200px) 1fr 200px; } }
  @media (max-width: 1199px) {
    .Product-module-Row_2AA {
      grid-template-areas: 'header body' 'header footer';
      grid-template-columns: minmax(164px, 200px) 1fr; } }
  @media (max-width: 767px) {
    .Product-module-Row_2AA {
      display: flex;
      flex-direction: column; } }

@media (max-width: 767px) {
  .Product-module-Row_2AA .Product-module-ProductBody_hFy {
    width: 100%; } }

.Product-module-Row_2AA .Product-module-ProductFooter_3Rv {
  flex-shrink: 0;
  width: 200px;
  row-gap: 16px; }
  @media (max-width: 767px) {
    .Product-module-Row_2AA .Product-module-ProductFooter_3Rv {
      width: 100%;
      row-gap: 8px; } }

.Product-module-Row_2AA .Product-module-ProductFooter_3Rv.Product-module-Skeleton_1Bx {
  row-gap: 8px; }
  @media (max-width: 767px) {
    .Product-module-Row_2AA .Product-module-ProductFooter_3Rv.Product-module-Skeleton_1Bx {
      margin-top: 16px; } }

.Product-module-SkeletonFullWidth_229 {
  width: 100%; }

.Product-module-SkeletonSizeX_t04 {
  height: 16px; }

.Product-module-SkeletonSizeM_3qs {
  height: 20px; }

.Product-module-SkeletonSizeL_lr0 {
  height: 24px; }

.Product-module-SkeletonSizeXL_1lK {
  height: 40px; }

.Product-module-SkeletonImage_3M2 {
  width: 100%;
  height: 0;
  padding-bottom: 100%; }

.Product-module-SkeletonTitle_3MD {
  width: 100%;
  max-width: 454px;
  height: 24px;
  margin-bottom: 8px; }
  @media (max-width: 767px) {
    .Product-module-SkeletonTitle_3MD {
      max-width: 90%;
      height: 16px;
      margin-bottom: 0; } }

.Product-module-SkeletonText_3UG {
  width: 100%;
  max-width: 232px;
  height: 16px; }
  @media (max-width: 767px) {
    .Product-module-SkeletonText_3UG {
      display: none;
      height: 16px; } }
  @media (max-width: 767px) {
    .Product-module-SkeletonText_3UG:last-child {
      display: initial;
      max-width: 90%; } }

.Product-module-SkeletonTextSmall_3r4 {
  max-width: 172px;
  margin-bottom: 8px; }

.Product-module-SkeletonPrice_3gb {
  width: 100%;
  max-width: 168px;
  height: 24px; }
  @media (max-width: 767px) {
    .Product-module-SkeletonPrice_3gb {
      max-width: 82%;
      height: 20px; } }

.Product-module-SkeletonBonus_1tB {
  width: 100%;
  max-width: 106px;
  height: 20px;
  margin: 8px 0; }
  @media (max-width: 767px) {
    .Product-module-SkeletonBonus_1tB {
      height: 20px; } }

.Product-module-SkeletonButton_s5a {
  width: 100%;
  height: 40px;
  border-radius: 40px; }
  @media (max-width: 767px) {
    .Product-module-SkeletonButton_s5a {
      height: 32px; } }
`, "",{"version":3,"sources":["webpack://./node_modules/@npm-registry/eapteka-ui/es/components/Product/Product.css"],"names":[],"mappings":"AAAA,wCAAwC;AACxC,sBAAsB;AACtB;EACE,aAAa;EACb,aAAa;EACb,uBAAuB;EACvB,WAAW;EACX,YAAY,EAAE;;AAEhB;EACE,kBAAkB;EAClB,iBAAiB;EACjB,WAAW,EAAE;;AAEf;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,eAAe;EACf,eAAe;EACf,YAAY,EAAE;;AAEhB;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,iBAAiB;EACjB,eAAe,EAAE;EACjB;IACE,QAAQ,EAAE;;AAEd;EACE,aAAa;EACb,sBAAsB;EACtB,oBAAoB,EAAE;;AAExB;EACE,YAAY,EAAE;EACd;IACE,gBAAgB,EAAE;IAClB;MACE;QACE,gBAAgB,EAAE,EAAE;;AAE5B;EACE,gBAAgB,EAAE;EAClB;IACE;MACE,gBAAgB,EAAE,EAAE;;AAE1B;EACE,cAAc;EACd,gBAAgB,EAAE;;AAEpB;EACE,aAAa,EAAE;EACf;IACE,gBAAgB;IAChB,cAAc;IACd,YAAY,EAAE;IACd;MACE;QACE,YAAY,EAAE,EAAE;;AAExB;EACE,yCAAyC;EACzC,sCAAsC;EACtC,gBAAgB,EAAE;EAClB;IACE;MACE,gBAAgB;MAChB,qDAAqD,EAAE,EAAE;EAC7D;IACE;MACE,kDAAkD;MAClD,+CAA+C,EAAE,EAAE;EACvD;IACE;MACE,aAAa;MACb,sBAAsB,EAAE,EAAE;;AAEhC;EACE;IACE,WAAW,EAAE,EAAE;;AAEnB;EACE,cAAc;EACd,YAAY;EACZ,aAAa,EAAE;EACf;IACE;MACE,WAAW;MACX,YAAY,EAAE,EAAE;;AAEtB;EACE,YAAY,EAAE;EACd;IACE;MACE,gBAAgB,EAAE,EAAE;;AAE1B;EACE,WAAW,EAAE;;AAEf;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,YAAY,EAAE;;AAEhB;EACE,WAAW;EACX,SAAS;EACT,oBAAoB,EAAE;;AAExB;EACE,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,kBAAkB,EAAE;EACpB;IACE;MACE,cAAc;MACd,YAAY;MACZ,gBAAgB,EAAE,EAAE;;AAE1B;EACE,WAAW;EACX,gBAAgB;EAChB,YAAY,EAAE;EACd;IACE;MACE,aAAa;MACb,YAAY,EAAE,EAAE;EACpB;IACE;MACE,gBAAgB;MAChB,cAAc,EAAE,EAAE;;AAExB;EACE,gBAAgB;EAChB,kBAAkB,EAAE;;AAEtB;EACE,WAAW;EACX,gBAAgB;EAChB,YAAY,EAAE;EACd;IACE;MACE,cAAc;MACd,YAAY,EAAE,EAAE;;AAEtB;EACE,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,aAAa,EAAE;EACf;IACE;MACE,YAAY,EAAE,EAAE;;AAEtB;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB,EAAE;EACrB;IACE;MACE,YAAY,EAAE,EAAE","sourcesContent":["/*  imported from Product.module.scss  */\n/* stylelint-disable */\n.Product-module-ProductRoot_24E {\n  display: grid;\n  row-gap: 16px;\n  align-items: flex-start;\n  width: 100%;\n  height: auto; }\n\n.Product-module-ProductHeader_zOD {\n  position: relative;\n  grid-area: header;\n  width: 100%; }\n\n.Product-module-ProductBody_hFy {\n  display: flex;\n  flex-direction: column;\n  align-items: baseline;\n  grid-area: body;\n  max-width: 100%;\n  row-gap: 8px; }\n\n.Product-module-ProductFooter_3Rv {\n  display: flex;\n  flex-direction: column;\n  align-items: baseline;\n  grid-area: footer;\n  max-width: 100%; }\n  .Product-module-Skeleton_1Bx .Product-module-ProductFooter_3Rv {\n    gap: 8px; }\n\n.Product-module-Column_2-x {\n  display: flex;\n  flex-direction: column;\n  align-items: stretch; }\n\n.Product-module-Column_2-x .Product-module-ProductFooter_3Rv {\n  row-gap: 8px; }\n  .Product-module-Column_2-x .Product-module-ProductFooter_3Rv.Product-module-Skeleton_1Bx {\n    margin-top: 32px; }\n    @media (max-width: 767px) {\n      .Product-module-Column_2-x .Product-module-ProductFooter_3Rv.Product-module-Skeleton_1Bx {\n        margin-top: 16px; } }\n\n.Product-module-Column_2-x .Product-module-ProductFooter_3Rv.Product-module-Skeleton_1Bx {\n  margin-top: 32px; }\n  @media (max-width: 767px) {\n    .Product-module-Column_2-x .Product-module-ProductFooter_3Rv.Product-module-Skeleton_1Bx {\n      margin-top: 16px; } }\n\n.Product-module-Column_2-x .Product-module-SkeletonTitle_3MD {\n  max-width: 90%;\n  margin-bottom: 0; }\n\n.Product-module-Column_2-x .Product-module-SkeletonText_3UG {\n  display: none; }\n  .Product-module-Column_2-x .Product-module-SkeletonText_3UG:last-child {\n    display: initial;\n    max-width: 90%;\n    height: 24px; }\n    @media (max-width: 767px) {\n      .Product-module-Column_2-x .Product-module-SkeletonText_3UG:last-child {\n        height: 16px; } }\n\n.Product-module-Row_2AA {\n  grid-template-areas: 'header body footer';\n  grid-template-columns: 200px 1fr 200px;\n  column-gap: 32px; }\n  @media (max-width: 1439px) {\n    .Product-module-Row_2AA {\n      column-gap: 16px;\n      grid-template-columns: minmax(164px, 200px) 1fr 200px; } }\n  @media (max-width: 1199px) {\n    .Product-module-Row_2AA {\n      grid-template-areas: 'header body' 'header footer';\n      grid-template-columns: minmax(164px, 200px) 1fr; } }\n  @media (max-width: 767px) {\n    .Product-module-Row_2AA {\n      display: flex;\n      flex-direction: column; } }\n\n@media (max-width: 767px) {\n  .Product-module-Row_2AA .Product-module-ProductBody_hFy {\n    width: 100%; } }\n\n.Product-module-Row_2AA .Product-module-ProductFooter_3Rv {\n  flex-shrink: 0;\n  width: 200px;\n  row-gap: 16px; }\n  @media (max-width: 767px) {\n    .Product-module-Row_2AA .Product-module-ProductFooter_3Rv {\n      width: 100%;\n      row-gap: 8px; } }\n\n.Product-module-Row_2AA .Product-module-ProductFooter_3Rv.Product-module-Skeleton_1Bx {\n  row-gap: 8px; }\n  @media (max-width: 767px) {\n    .Product-module-Row_2AA .Product-module-ProductFooter_3Rv.Product-module-Skeleton_1Bx {\n      margin-top: 16px; } }\n\n.Product-module-SkeletonFullWidth_229 {\n  width: 100%; }\n\n.Product-module-SkeletonSizeX_t04 {\n  height: 16px; }\n\n.Product-module-SkeletonSizeM_3qs {\n  height: 20px; }\n\n.Product-module-SkeletonSizeL_lr0 {\n  height: 24px; }\n\n.Product-module-SkeletonSizeXL_1lK {\n  height: 40px; }\n\n.Product-module-SkeletonImage_3M2 {\n  width: 100%;\n  height: 0;\n  padding-bottom: 100%; }\n\n.Product-module-SkeletonTitle_3MD {\n  width: 100%;\n  max-width: 454px;\n  height: 24px;\n  margin-bottom: 8px; }\n  @media (max-width: 767px) {\n    .Product-module-SkeletonTitle_3MD {\n      max-width: 90%;\n      height: 16px;\n      margin-bottom: 0; } }\n\n.Product-module-SkeletonText_3UG {\n  width: 100%;\n  max-width: 232px;\n  height: 16px; }\n  @media (max-width: 767px) {\n    .Product-module-SkeletonText_3UG {\n      display: none;\n      height: 16px; } }\n  @media (max-width: 767px) {\n    .Product-module-SkeletonText_3UG:last-child {\n      display: initial;\n      max-width: 90%; } }\n\n.Product-module-SkeletonTextSmall_3r4 {\n  max-width: 172px;\n  margin-bottom: 8px; }\n\n.Product-module-SkeletonPrice_3gb {\n  width: 100%;\n  max-width: 168px;\n  height: 24px; }\n  @media (max-width: 767px) {\n    .Product-module-SkeletonPrice_3gb {\n      max-width: 82%;\n      height: 20px; } }\n\n.Product-module-SkeletonBonus_1tB {\n  width: 100%;\n  max-width: 106px;\n  height: 20px;\n  margin: 8px 0; }\n  @media (max-width: 767px) {\n    .Product-module-SkeletonBonus_1tB {\n      height: 20px; } }\n\n.Product-module-SkeletonButton_s5a {\n  width: 100%;\n  height: 40px;\n  border-radius: 40px; }\n  @media (max-width: 767px) {\n    .Product-module-SkeletonButton_s5a {\n      height: 32px; } }\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
